import util from '@bmp-vue/core/api/util'
const controller = 'Consiga'
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  GetParcelas () {
    return [
      { nParcelas: 12, taxas: [5.91] },
      { nParcelas: 24, taxas: [4.17, 4.36, 5.13, 5.89] },
      { nParcelas: 36, taxas: [2.80, 3.08, 3.61, 3.99] },
      { nParcelas: 42, taxas: [3.85, 3.98, 4.09, 4.20, 4.30, 4.40, 4.49, 4.59, 4.56, 4.66, 4.77, 4.86, 4.73, 4.84, 4.94, 5.06] },
      { nParcelas: 48, taxas: [2.92, 3.18, 3.71, 4.09] }
    ]
  },
  GetItem (parcela) {
    return ctrl.GetParcelas().find(item => item.nParcelas === parcela)?.taxas;
  },
  ChangeVlrProdutoBem (th, value) {
    let vlrEntrada = 0
    if (value) {
      value = th.$api.UI.Parse.Decimal(value)
      vlrEntrada = parseFloat((value * th.$param.VlrMinEntrada).toFixed(2))
    }
    th.$set(th.model, 'VlrEntrada', vlrEntrada)
  },
  SavePropostaCampoAuxiliar (th) {
    const campos = []

    if ([null, undefined].indexOf(th.model.PropostaDadosVeiculo.ZeroKM) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTAVEICULO_ZEROKM', ValorCampo: th.model.PropostaDadosVeiculo.ZeroKM }) }
    if ([null, undefined].indexOf(th.model.ModeloComissao) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_MODELOCOMISSAO', ValorCampo: th.model.ModeloComissao }) }
    if ([null, undefined].indexOf(th.model.ObservacaoVendedor) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_OBSERVACAOVENDEDOR', ValorCampo: th.model.ObservacaoVendedor }) }
    if ([null, undefined].indexOf(th.model.PropostaDadosVeiculo.Cilindradas) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTAVEICULO_CILINDRADAS', ValorCampo: th.model.PropostaDadosVeiculo.Cilindradas }) }

    if (campos.length > 0) { th.$api.Multiplo.Post('SavePropostaCampoAuxiliar', { dto: campos }) }
  },
  CadastraAssinantes (th, documentoEmitente, callback) {
    const assinantes = [];
    const parameters = [{ name: 'CodigoProposta', value: th.model.Codigo }]
    th.$api.Multiplo.Post('CarregarPropostaParticipantes', { parameters }).then(res => {
      th.$api.Multiplo.Post('FindRecordProdutoRede').then(function (resProdutoRede) {
        res.forEach(assinante => {
          const addAssinante = {
            Nome: assinante.Nome,
            Documento: assinante.Documento,
            NotificarPorEmail: th.$aux.NotificaPorEmail.includes(resProdutoRede.ModeloNotificacaoAssinatura),
            NotificarPorWhatsApp: th.$aux.NotificaPorWhatsApp.includes(resProdutoRede.ModeloNotificacaoAssinatura),
            Descricao: assinante.Documento === th.$api.UI.Format.SomenteNumeros(documentoEmitente) ? 'EMITENTE' : 'AVALISTA',
            TelefoneCelular: assinante.TelefoneCelular,
            Email: assinante.Email
          }

          assinantes.push(addAssinante);
        })

        if (assinantes.length > 0) {
          const dto = {
            CodigoProposta: th.model.Codigo,
            CodigoOperacao: th.model.CodigoOperacao
          }

          th.$api.Multiplo.Post('PropostaAssinaturaCCB', { dto, assinantes }).then(response => {
            if (th.$api.UI.PostAction(response)) {
              if (callback && typeof callback === 'function') callback();
            }
          })
        }
      })
    })
  },
  AllowedDates (th, value) {
    return ![0, 6].includes(th.$api.UI.Parse.Date(value).getDay())
  },
})

export default ctrl
